import styled from 'styled-components';

export const EmptyTableWrapper = styled.div`
  position: relative;
  min-height: 100vh;
`;

export const EmptyContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  align-items: center;
  padding-top: 120px;
  padding-bottom: 120px;
  text-align: center;
  width: 100%;
`;

export const EmptyIconWrapper = styled.div`
  width: auto;
  height: 250px;
`;

export const EmptyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyContentTitle = styled.h2`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const EmptyContentSubtitle = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
